import styled from '@emotion/styled';

export const SettingsMenuBox = styled.div`
  display: flex;
  align-items: center;
  height: 46px;
`;
